<style scoped>
  .orders-table-header {
    border-bottom: 1px solid var(--color-border);
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 5px;
    text-align: left;
    font-size: 12px;
    color: var(--color-text-dark);
  }
  .orders-table {
    border-collapse: collapse;
    width: 96%;
    margin-bottom: 20px;
    margin-left: 15px;
    /*margin-right: 15px;*/
    font-size: 12px;
  }
  .tablerow {
    /*background-color: #3a3d5a;*/
    height: 32px;
  }
  .oddrow {
    background-color: var(--color-card);
  }
  .symbol {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 18px;
    font-weight: normal;
    padding-top: 5px;
    margin-left: 15px;
  }
  .bot-name {
    color: var(--color-text-dark);
    font-weight: bold;
    padding-bottom: 5px;
    font-size: 16px;
    margin-left: 15px;
  }
  .right-padding {
    padding-right: 5px;
  }
  .red {
    color:var(--color-danger-light);
  }

  .green {
    color: var(--color-success-light);
  }
</style>

<template>
  <div>
    <Modal :value="show" width="1000" @input="$emit('on-cancel', $event)">
      <div class="symbol">
        <CoinIcon :symbol="symbolText" />
        <span>{{ symbolText }}</span>
      </div>
      <div class="bot-name" style="cursor: pointer" @click="$copyToClipboardAndNotify(botName)"> {{ botName }}</div>
      <table class="orders-table">
        <tr>
<!--          <th class="orders-table-header">ID</th>-->
          <th class="orders-table-header" style="width: 60px;">#</th>
          <th class="orders-table-header">{{ $text.tr('ДАТА')}}</th>
          <th class="orders-table-header">{{ $text.tr('НАПРАВЛЕНИЕ')}}</th>
          <th class="orders-table-header">{{ $text.tr('КОЛ-ВО')}}</th>
          <th class="orders-table-header">{{ $text.tr('ЦЕНА')}}</th>
          <th class="orders-table-header">{{ $text.tr('СУММА')}}</th>
          <th class="orders-table-header">{{ $text.tr('КОМИССИЯ БИРЖИ') }}</th>
          <th class="orders-table-header">{{ $text.tr('ПРИБЫЛЬ')}}</th>
          <th v-if="profincoin" class="orders-table-header">{{ $text.tr('МОНЕТ')}}</th>
          <!-- <th class="orders-table-header">{{ $text.tr('СТАТУС')}}</th> -->
        </tr>
        <template v-for="order in orders">
          <tr :key="order.Id" class="tablerow">
<!--            <td class="right-padding">-->
<!--              #{{ order.Id }}-->
<!--            </td>-->
            <td class="right-padding">
              <div style="cursor: pointer" @click="$copyToClipboardAndNotify(order.oid)">{{ order.oid }}</div>
            </td>
            <td class="right-padding">
              <div>
                {{ localTime(order.executed) }}
              </div>
            </td>
            <td class="right-padding">
              <div v-if="order.side === 'b'" style="color: var(--color-success-light)">{{ $text.tr('ПОКУПКА')}}</div>
              <div v-if="order.side === 's'" style="color:var(--color-danger-light)">{{ $text.tr('ПРОДАЖА')}}</div>
            </td>
            <td class="right-padding">
              <div>{{ order.qty }}</div>
            </td>
            <td class="right-padding">
              {{ order.price }}
            </td>
            <td class="right-padding">
              {{ returnAmount(order.qty, order.price) }}
            </td>
            <td class="right-padding">
              <div v-if="order.fee != ''">
                {{ order.fee }}
              </div>
            </td>
            <td class="right-padding">
              <div v-if="order.profit !== '0'" :class="{'red' : parseFloat(order.profit) < 0, 'green' : parseFloat(order.profit) >= 0}">
                {{ order.profit }}
              </div>
            </td>
            <td v-if="profincoin" class="right-padding">
              <div v-if="order.coin_profit && order.coin_profit !== '0'" class="green">
                {{ order.coin_profit }}
              </div>
            </td>
            <!-- <td>
              {{ $text.tr(returnStatus(order.Status)) }}
            </td> -->
          </tr>
        </template>
      </table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import CoinIcon from '@/components/common/CoinIcon'
import Decimal from 'decimal.js'

export default {
  components: { CoinIcon },
  name: 'GridOrdersModal',
  props: ['show', 'orders', 'botName', 'symbol', 'profincoin'],
  data () {
    return {
      symbolText: ''
    }
  },
  watch: {
    'symbol': function () {
      if (this.symbol) {
        const assets = this.symbol.split('_')
        this.symbolText = assets[0] + '/' + assets[1]
      }
    }
  },
  computed: {
  },
  methods: {
    returnAmount (qty, price) {
      const filt = this.$store.state.data.symbolsfilter[this.symbol]
      if (!filt) {
        return
      }
      const amountDec = parseFloat(filt.PriceDec) + parseFloat(filt.QtyDec)
      const amount = new Decimal(qty).mul(new Decimal(price)).toDP(amountDec).toString()
      return amount
    },
    // returnStatus (status) {
    //   if (status === 'EXC') {
    //     return 'ИСПОЛНЕН'
    //   } else if (status === 'ACT') {
    //     return 'РАЗМЕЩЕН'
    //   } else if (status === 'CNL') {
    //     return 'ОТМЕНЕН'
    //   }
    //   return status
    // },
    localTime (utctime) {
      return new Date(utctime).toLocaleString('ru-RU').replace(',', '')
    }
  }
}
</script>
